module.exports = __webpack_public_path__ + "img/17ne.31d0666e.svg";